var ItemModel = (function (Model, CheckoutSettings, PromiseUtil) {

    var ItemModel = Model.extend({
        initialize: function(data) {

            var displayDiscount = data.SubtotalWithDiscount &&
                data.SubtotalWithDiscount > 0 &&
                data.DiscountPercentOff &&
                data.DiscountPercentOff > 0;

            var multibuyDescription = '[[Price]] for each item when you purchase [[Count]] or more products in this sale';
            
            if (!data.Discount) {
                this.set('MultiBuyDiscount', window.toMoney((data.MultiBuyDiscountPrice / data.MultiBuyCount) * data.Qty, GlobalSettings.CurrencySign));
                this.set('MultiBuyActive', false);
            } else {
                this.set('MultiBuyDiscount', window.toMoney(data.SubtotalWithDiscount, GlobalSettings.CurrencySign));
                this.set('MultiBuyActive', true);
            }
            var description = multibuyDescription
                .replace(/\[\[Price\]\]/gi, window.toMoney(data.MultiBuyDiscountPrice / data.MultiBuyCount, GlobalSettings.CurrencySign))
                .replace(/\[\[Count\]\]/gi, data.MultiBuyCount);
            this.set('MultiBuyDescription', description);

            this.set('DisplayDiscount', displayDiscount);
            if (displayDiscount) {
                this.set('DiscountAmount', window.toMoney(data.SubtotalWithDiscount, GlobalSettings.CurrencySign));
                this.set('DiscountPercentOff', data.DiscountPercentOff);
            }

            Model.prototype.initialize.apply(this, arguments);
        }
    });

	return ItemModel.extend({
		idAttribute: 'ID',

		increase: function () {
                window.app && app.event && app.event.increaseItemQty();
				return this._api.increaseOrderItem(this.get('ID'), CheckoutSettings.imageSize, { abortOnRetry: false }).done(this._updateCheckout);
		},

        decrease: function () {
            window.app && app.event && app.event.decreaseItemQty();
			return this._api.decreaseOrderItem(this.get('ID'), CheckoutSettings.imageSize, { abortOnRetry: false }).done(this._updateCheckout);
		},

        delete: function () {
            window.app && app.event && app.event.deleteOrderItem();
            return this._api.deleteOrderItem(this.get('ID'), { abortOnRetry: false }).done(this._updateCheckout);
		},

		getImageUrl: function () {
			return GlobalSettings.SecureImageServerURL + 'brands/' + this.get('BrandID') + '/' + this.get('ImageID') + '/' + this.get('FileName');
		},

		getProductLink: function () {
			return location.protocol + '//' + window.location.host + '/Product.aspx?' + (globalQueryParams.cid ? 'cid=' + globalQueryParams.cid : '') + '&saleID=' + kos.guidToBase64(this.get('SaleID')) + '&productID=' + kos.guidToBase64(this.get('ItemID'));
		}
	});
})(CheckoutApiModel, CheckoutSettings, PromiseUtil);
